<div class="loader-overlay" *ngIf="isLoading">
  <p-progressSpinner
    styleClass="w-4rem h-4rem"
    strokeWidth="8"
    fill="transparent"
    animationDuration="1s"
  ></p-progressSpinner>
</div>
